module.exports = __webpack_public_path__ + "img/Brassica_napus.77ce2cce.jpg";